import axios from '../utils/axios'

export function getCouponActivityList(params) {
  return axios.post('/user/apiUserAwService/couponActivityCenter', params)
}

export function getMemberCouponList(params) {
  return axios.post('/user/apiUserAwService/getMemberCouponList', params)
}

// 领取活动优惠券
export function receiveActivityCoupon(params) {
  return axios.post('/user/apiUserAwService/receiveActivityCoupon', params, { isTransformRes: false })
}

// 获取优惠券详情
export function memberCouponReceiveInfo(params) {
  return axios.post('/user/apiUserAwService/memberCouponReceiveInfo', params)
}

// 获取活动详情
export function getCouponActivityInfo(params) {
  return axios.post('/user/apiUserAwService/couponActivityInfo', params)
}

export function couponReceiveId(params) {
  return axios.post('/user/apiUserAwService/couponReceiveId', params)
}

//获取兑换商品列表
export function getExchangeGoodsListApi(params) {
  return axios.post('/settle/apiSettleAwService/getExchangeGoodsList', params)
}
// 我的兑换券
export function getMyExchangeCouponInfoApi(params) {
  return axios.post('/settle/apiSettleAwService/getMyExchangeCouponInfo', params)
}
//优惠券详情
export function getMemberCouponDetailApi(params) {
  return axios.post('/settle/apiSettleAwService/getMemberCouponDetail', params)
}
//// 取消转赠优惠券
export function postCancelCouponTransferApi(params) {
  return axios.post('/user/apiUserAwService/couponTransCancel', params)
}
